import {EntryPath} from './nativeLaunchTypes'

export function convertEntryPathToRoute(entryPath: EntryPath): string {
  // This layer detaches the backend-side naming conventions from the frontend routing conventions.
  switch (entryPath.workflow) {
    case 'build':
      return `/build/${entryPath.resourceId ?? ''}`
    case 'taking':
      return `/taking/${entryPath.resourceId ?? ''}`
    case 'observing':
      return `/observing/${entryPath.resourceId ?? ''}`
    case 'course_concluded':
      return '/course_concluded'
    case 'errors':
      return '/errors/400'
    default:
      return '/errors/400'
  }
}
